import { Component } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { strict } from 'assert';
import { AirlineMasterService } from '../Services/airline-master.service';
import { AirlineMasterProperties } from '../Models/AirlineMasterProperties';
import { Canvg } from 'canvg';
import {$ } from 'jquery'
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { DxLoadPanelModule, DxDataGridModule } from 'devextreme-angular';
import { FormsModule } from '@angular/forms';
import { DxoSelectionModule, DxoPagerModule, DxoPagingModule, DxoFilterRowModule, DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';

@Component({
    selector: 'app-airlines-master',
    templateUrl: './airlines-master.component.html',
    styleUrls: ['./airlines-master.component.css'],
    imports: [NavMenuComponent, DxLoadPanelModule, FormsModule, DxDataGridModule, DxoSelectionModule, DxoPagerModule, DxoPagingModule, DxoFilterRowModule, DxiColumnModule, DxTemplateModule]
})
/** AirlinesMaster component*/
export class AirlinesMasterComponent {
  /** AirlinesMaster ctor */
  constructor(private airlineservice: AirlineMasterService, private modalService: NgbModal,) {

  }

  contentReady = () => {
    $(".dx-datagrid-headers").css({ "background-color": "white", "color": "#212529", "font-weight": "bold", "font-size": "15px" });

  };
  airlineMasterinfo: AirlineMasterProperties[] = [];
  airlineMasterObj=new  AirlineMasterProperties();
  airlineMasterCreateObj=new  AirlineMasterProperties();
  isLoadPanelVisible: boolean = false;
  ValidateFileFormat: boolean;
  url: string | ArrayBuffer;
  imagePath: string = "";
  message: string = "";
  ngOnInit() {
    this.isLoadPanelVisible = true;
    this.GetAirlineData();
  }
  GetAirlineData() {
    this.airlineservice.getAirlinesData().subscribe((data) => {
      if (data.length > 0) {
        this.isLoadPanelVisible = false;
        this.airlineMasterinfo = data;
      }
    })
  }
  DeleteAirline(id, targetmodel, model) {
    console.log(id);
    this.airlineservice.DeleteAirlineDetails(id, Number(localStorage.getItem("UserId"))).subscribe((data) => {
      if (data == true) {
        this.GetAirlineData();
        this.modalService.open(targetmodel, {

          /* windowClass: "searchpassengerpopupmodal"*/

          windowClass: "alertpopupmodal"
        })
        setTimeout(() => { this.modalService.dismissAll() }, 5000);
      }
      else {
        this.modalService.open(model, {

          /* windowClass: "searchpassengerpopupmodal"*/

          windowClass: "alertpopupmodal"
        })
      }
    })
  }

  validateFileType(fileName): boolean {
   
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile == "svg" || extFile == "png") {
      //TO DO
      this.ValidateFileFormat = true;
    } else {
      this.ValidateFileFormat = false;
    }
    return this.ValidateFileFormat;
  }
  ssvgurl: string;
  UpdateFileImage: any;
  onFileChanged(event, targetmodel) {
    this.url = "";
    const files = event.target.files;
    this.UpdateFileImage = event.target.files[0].name;
    this.airlineMasterObj.airlineLogo = event.target.files[0];
    if (files.length === 0) {
      return;
    }
    const filename = event.target.files[0].name;
    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    if (this.validateFileType(filename) == true) {
      var idxDot = filename.lastIndexOf(".") + 1;
      var extFile = filename.substr(idxDot, filename.length).toLowerCase();
      if (extFile == "svg") {
        const reader = new FileReader();
        this.imagePath = files;
        reader.readAsDataURL(files[0]);
        let imageurl = document.getElementById("svg") as HTMLImageElement;
        imageurl.style.display = "none";
        reader.onload =  async (_event) => {
          
          imageurl.src = (reader.result).toString();
          const canvass = document.createElement('canvas');
          canvass.id = "newcanvas";
          canvass.width = 250;
          canvass.height = 250;
          const ctx = canvass.getContext('2d');
         /* ctx.clearRect(0, 0, canvass.width, canvass.height);*/
          const v = await Canvg.from(ctx, imageurl.src);

          v.start();
          var processedimage = canvass.toDataURL("img/png");
          //var s = new XMLSerializer().serializeToString(imageurl.src);
          //var encodedData = window.btoa(s);
          //this.ssvgurl = encodedData;
          this.url = "";
          this.url = processedimage;
         
          
          
       
        }
       
      }
      else {
       
        this.ssvgurl = "";
          const reader = new FileReader();
          this.imagePath = files;
          reader.readAsDataURL(files[0]);
          reader.onload = (_event) => {
            this.url = reader.result;
         
          }
      }

      
    }
    else {
      
      document.getElementById("messageLogo1").innerHTML = "Only .svg & .png Formats Are Allowed";
      this.url = "";
      setTimeout(() => { document.getElementById("messageLogo1").innerHTML = ""; }, 5000);
      return;
    }
    //document.body.removeChild(document.getElementById("newcanvas"));
    this.modalService.dismissAll();
    this.modalService.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/

      size: 'lg',
    })
  }
  createFileImage: any;
  onFileChangedCreate(event, targetmodel) {
    this.ssvgurl = "";
    const filess = event.target.files;
    this.createFileImage= event.target.files[0];
    this.airlineMasterCreateObj.airlineLogo = event.target.files[0];
    if (filess.length === 0) {
      return;
    }
    const filename = event.target.files[0].name;
    const mimeType = filess[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    if (this.validateFileType(filename) == true) {
      var idxDot = filename.lastIndexOf(".") + 1;
      var extFile = filename.substr(idxDot, filename.length).toLowerCase();
      if (extFile == "svg") {
        const reader = new FileReader();
        this.imagePath = filess;
        reader.readAsDataURL(filess[0]);
        let imageurl = document.getElementById("svg") as HTMLImageElement;
        imageurl.style.display = "none";
        reader.onload = async (_event) => {

          imageurl.src = (reader.result).toString();
          const canvass = document.createElement('canvas');
          canvass.id = "newcanvas";
          canvass.width = 250;
          canvass.height = 250;
          const ctx = canvass.getContext('2d');
          /* ctx.clearRect(0, 0, canvass.width, canvass.height);*/
          const v = await Canvg.from(ctx, imageurl.src);

          v.start();
          var processedimage = canvass.toDataURL("img/png");
          //var s = new XMLSerializer().serializeToString(imageurl.src);
          //var encodedData = window.btoa(s);
          //this.ssvgurl = encodedData;
          this.ssvgurl = "";
          this.ssvgurl = processedimage;




        }

      }
      else {

     
        const reader = new FileReader();
        this.imagePath = filess;
        reader.readAsDataURL(filess[0]);
        reader.onload = (_event) => {
          this.ssvgurl = (reader.result).toString();

        }
      }


    }
    else {

      document.getElementById("messageLogo1").innerHTML = "Only .svg & .png Formats Are Allowed";
      this.url = "";
      setTimeout(() => { document.getElementById("messageLogo1").innerHTML = ""; }, 5000);
      return;
    }
    //document.body.removeChild(document.getElementById("newcanvas"));
    this.modalService.dismissAll();
    this.modalService.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/

      size: 'lg',
    })
  }
  popupCreateModel(targetmodel) {
    this.modalService.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/

      size: 'lg',
    })
  }
  CreateAirline(event, targetmodel, bad) {
  
    if (this.airlineMasterCreateObj.airlineCombineCode == undefined || this.airlineMasterCreateObj.airlineCombineCode == null ||
      this.airlineMasterCreateObj.airlineCombineCode == "") {
      document.getElementById("airlineCombineCode1").innerHTML = 'Required';
      document.getElementById("combineinput").style.borderColor = "red";
      document.getElementById("combineinput").style.boxShadow = "0 0 3px red";
      setTimeout(() => {
        document.getElementById("airlineCombineCode1").innerHTML = '';
        document.getElementById("combineinput").style.borderColor = "";
        document.getElementById("combineinput").style.boxShadow = ""; }, 5000);
    }
    if (this.airlineMasterCreateObj.airlineLegalName == undefined || this.airlineMasterCreateObj.airlineLegalName == null ||
      this.airlineMasterCreateObj.airlineLegalName == "") {
      document.getElementById("airlineLegalName1").innerHTML = 'Required';
      document.getElementById("legalinput").style.borderColor = "red";
      document.getElementById("legalinput").style.boxShadow = "0 0 3px red";
      setTimeout(() => {
        document.getElementById("airlineLegalName1").innerHTML = '';
        document.getElementById("legalinput").style.borderColor = "";
        document.getElementById("legalinput").style.boxShadow = "";
      }, 5000);
    }
    if (this.airlineMasterCreateObj.airlinePrefixCode == undefined || this.airlineMasterCreateObj.airlinePrefixCode == null ||
      this.airlineMasterCreateObj.airlinePrefixCode == "") {
      document.getElementById("airlinePrefixCode1").innerHTML = 'Required';
      document.getElementById("prefixinput").style.borderColor = "red";
      document.getElementById("prefixinput").style.boxShadow = "0 0 3px red";
      setTimeout(() => {
        document.getElementById("airlinePrefixCode1").innerHTML = '';
        document.getElementById("prefixinput").style.borderColor = "";
        document.getElementById("prefixinput").style.boxShadow = "";
      }, 5000);
    }
    if (this.airlineMasterCreateObj.airlineNumCode == undefined || this.airlineMasterCreateObj.airlineNumCode == null ||
      this.airlineMasterCreateObj.airlineNumCode == "") {
      document.getElementById("airlineNumCode1").innerHTML = 'Required';
      document.getElementById("numberinput").style.borderColor = "red";
      document.getElementById("numberinput").style.boxShadow = "0 0 3px red";
      setTimeout(() => {
        document.getElementById("airlineNumCode1").innerHTML = '';
        document.getElementById("numberinput").style.borderColor = "";
        document.getElementById("numberinput").style.boxShadow = "";
      }, 5000);
    }

    if (this.airlineMasterCreateObj.airlineLogo == undefined || this.airlineMasterCreateObj.airlineLogo == null ||
      this.airlineMasterCreateObj.airlineLogo == "") {
      document.getElementById("messageLogo1").innerHTML = 'Required';

      setTimeout(() => {
        document.getElementById("messageLogo1").innerHTML = '';

      }, 5000);
    }
    if (this.airlineMasterCreateObj.airlineLogo == undefined || this.airlineMasterCreateObj.airlineLogo == null ||
      this.airlineMasterCreateObj.airlineLogo == "" || this.airlineMasterCreateObj.airlineNumCode == undefined || this.airlineMasterCreateObj.airlineNumCode == null ||
      this.airlineMasterCreateObj.airlineNumCode == "" || this.airlineMasterCreateObj.airlinePrefixCode == undefined || this.airlineMasterCreateObj.airlinePrefixCode == null ||
      this.airlineMasterCreateObj.airlinePrefixCode == "" || this.airlineMasterCreateObj.airlineLegalName == undefined || this.airlineMasterCreateObj.airlineLegalName == null ||
      this.airlineMasterCreateObj.airlineLegalName == "" || this.airlineMasterCreateObj.airlineCombineCode == undefined || this.airlineMasterCreateObj.airlineCombineCode == null ||
      this.airlineMasterCreateObj.airlineCombineCode == "") {
      return;
    }
    var formData = new FormData();

    formData.append("airlineID", (this.airlineMasterCreateObj.airlineID).toString());
    formData.append("airlineLegalName", this.airlineMasterCreateObj.airlineLegalName);
    formData.append("airlineCombineCode", this.airlineMasterCreateObj.airlineCombineCode);
    formData.append("airlineNumCode", this.airlineMasterCreateObj.airlineNumCode);
    formData.append("airlinePrefixCode", this.airlineMasterCreateObj.airlinePrefixCode);
    formData.append("airlineStatus", this.airlineMasterCreateObj.airlineStatus);
    formData.append("userId", (localStorage.getItem("UserId")));
    formData.append(this.createFileImage.name, this.airlineMasterCreateObj.airlineLogo)
    this.airlineservice.CreateAirlines(formData).subscribe((data) => {
      if (data == true) {
        this.GetAirlineData();
        this.modalService.dismissAll();
        this.modalService.open(targetmodel, {

          /* windowClass: "searchpassengerpopupmodal"*/

          windowClass: "alertpopupmodal"
        })
        setTimeout(() => { this.modalService.dismissAll() }, 5000);
      }
      
      else {
        this.modalService.open(bad, {

          /* windowClass: "searchpassengerpopupmodal"*/

          windowClass: "alertpopupmodal"
        })
        setTimeout(() => { this.modalService.dismissAll() }, 5000);
      }
      
    })
  }
  updatepopup(data, targetmodel) {
    this.airlineMasterObj.airlineID = data.airlineID;
    this.airlineMasterObj.airlineLegalName = data.airlineLegalName;
    this.airlineMasterObj.airlineLogoName = data.airlineLogoName;
    /*  this.newobj.ICAOCode = data.icaoCode;*/
    this.airlineMasterObj.airlineCombineCode = data.airlineCombineCode;
    this.airlineMasterObj.airlineNumCode = data.airlineNumCode;
    this.airlineMasterObj.airlinePrefixCode = data.airlinePrefixCode;
    this.airlineMasterObj.airlineStatus = data.airlineStatus;
    this.url = data.airlineLogo;
    this.airlineMasterObj.airlineLogo = data.airlineLogo;
    this.UpdateFileImage = data.airlineLogo;
    //console.log(data);
    this.modalService.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/

      size: 'lg',
    })
  }
  UpdateAirline(event,targetmodel, bad) {
    try {
     
      if (this.airlineMasterObj.airlineCombineCode == undefined || this.airlineMasterObj.airlineCombineCode == null ||
        this.airlineMasterObj.airlineCombineCode == "") {
        document.getElementById("airlineCombineCode2").innerHTML = 'Required';
        document.getElementById("combineinput").style.borderColor = "red";
        document.getElementById("combineinput").style.boxShadow = "0 0 3px red";
        setTimeout(() => {
          document.getElementById("airlineCombineCode2").innerHTML = '';
          document.getElementById("combineinput").style.borderColor = "";
          document.getElementById("combineinput").style.boxShadow = "";
        }, 5000);
      }
      if (this.airlineMasterObj.airlineLegalName == undefined || this.airlineMasterObj.airlineLegalName == null ||
        this.airlineMasterObj.airlineLegalName == "") {
        document.getElementById("airlineLegalName2").innerHTML = 'Required';
        document.getElementById("legalinput").style.borderColor = "red";
        document.getElementById("legalinput").style.boxShadow = "0 0 3px red";
        setTimeout(() => {
          document.getElementById("airlineLegalName2").innerHTML = '';
          document.getElementById("legalinput").style.borderColor = "";
          document.getElementById("legalinput").style.boxShadow = "";
        }, 5000);
      }
      if (this.airlineMasterObj.airlinePrefixCode == undefined || this.airlineMasterObj.airlinePrefixCode == null ||
        this.airlineMasterObj.airlinePrefixCode == "") {
        document.getElementById("airlinePrefixCode2").innerHTML = 'Required';
        document.getElementById("prefixinput").style.borderColor = "red";
        document.getElementById("prefixinput").style.boxShadow = "0 0 3px red";
        setTimeout(() => {
          document.getElementById("airlinePrefixCode2").innerHTML = '';
          document.getElementById("prefixinput").style.borderColor = "";
          document.getElementById("prefixinput").style.boxShadow = "";
        }, 5000);
      }
      if (this.airlineMasterObj.airlineNumCode == undefined || this.airlineMasterObj.airlineNumCode == null ||
        this.airlineMasterObj.airlineNumCode == "") {
        document.getElementById("airlineNumCode2").innerHTML = 'Required';
        document.getElementById("numberinput").style.borderColor = "red";
        document.getElementById("numberinput").style.boxShadow = "0 0 3px red";
        setTimeout(() => {
          document.getElementById("airlineNumCode2").innerHTML = '';
          document.getElementById("numberinput").style.borderColor = "";
          document.getElementById("numberinput").style.boxShadow = "";
        }, 5000);
      }
      if (this.airlineMasterObj.airlineLogo == undefined || this.airlineMasterObj.airlineLogo == null ||
        this.airlineMasterObj.airlineLogo == "") {
        document.getElementById("messageLogo1").innerHTML = 'Required';
    
        setTimeout(() => {
          document.getElementById("messageLogo1").innerHTML = '';

        }, 5000);
      }
      if (this.airlineMasterObj.airlineStatus == undefined || this.airlineMasterObj.airlineStatus == null ||
        this.airlineMasterObj.airlineStatus == "") {
        document.getElementById("airlineStatus2").innerHTML = 'Required';
        document.getElementById("statusinput2").style.borderColor = "red";
        document.getElementById("statusinput2").style.boxShadow = "0 0 3px red";
        setTimeout(() => {
          document.getElementById("airlineStatus2").innerHTML = '';
          document.getElementById("statusinput2").style.borderColor = "";
          document.getElementById("statusinput2").style.boxShadow = "";
        }, 5000);
      }
      if (this.airlineMasterObj.airlineLogo == undefined || this.airlineMasterObj.airlineLogo == null ||
        this.airlineMasterObj.airlineLogo == "" || this.airlineMasterObj.airlineNumCode == undefined || this.airlineMasterObj.airlineNumCode == null ||
        this.airlineMasterObj.airlineNumCode == "" || this.airlineMasterObj.airlinePrefixCode == undefined || this.airlineMasterObj.airlinePrefixCode == null ||
        this.airlineMasterObj.airlinePrefixCode == "" || this.airlineMasterObj.airlineLegalName == undefined || this.airlineMasterObj.airlineLegalName == null ||
        this.airlineMasterObj.airlineLegalName == "" || this.airlineMasterObj.airlineCombineCode == undefined || this.airlineMasterObj.airlineCombineCode == null ||
        this.airlineMasterObj.airlineCombineCode == "" || this.airlineMasterObj.airlineStatus == undefined || this.airlineMasterObj.airlineStatus == null ||
        this.airlineMasterObj.airlineStatus == "") {
        return;
      }
      var formData = new FormData();
     
      formData.append("airlineID", (this.airlineMasterObj.airlineID).toString());
      formData.append("airlineLegalName", this.airlineMasterObj.airlineLegalName);
      formData.append("airlineLogoName", this.airlineMasterObj.airlineLogoName);
      formData.append("airlineCombineCode", this.airlineMasterObj.airlineCombineCode);
      formData.append("airlineNumCode", this.airlineMasterObj.airlineNumCode);
      formData.append("airlinePrefixCode", this.airlineMasterObj.airlinePrefixCode);
      formData.append("airlineStatus", this.airlineMasterObj.airlineStatus);
      formData.append("arlineLogo", this.UpdateFileImage);
      formData.append("userId", (localStorage.getItem("UserId")));
      formData.append(this.UpdateFileImage, this.airlineMasterObj.airlineLogo)
      this.airlineservice.UpdateAirlines(formData).subscribe((data) => {
        if (data == true) {
          this.modalService.dismissAll();
          this.GetAirlineData();
        }

        else {
          this.modalService.open(bad, {

            /* windowClass: "searchpassengerpopupmodal"*/

            windowClass: "alertpopupmodal"
          })
          setTimeout(() => { this.modalService.dismissAll() }, 5000);
        }

      })
    }
    catch (e) {
      console.log(e);
    }
  }




  svg = `<svg xmlns="http://www.w3.org/2000/svg" width="348" height="314" viewBox="0 0 348 314">
  <g id="Group_430" data-name="Group 430" transform="translate(-1123 -491)">
    <g id="Group_429" data-name="Group 429" transform="translate(12 -9)">
      <rect id="Rectangle_288" data-name="Rectangle 288" width="348" height="314" rx="17" transform="translate(1111 500)" fill="#f9f9f9"/>
      <g id="Group_428" data-name="Group 428" transform="translate(1186.451 531.451)">
        <path id="Path_105" data-name="Path 105" d="M165.377,197.1H31.72A31.72,31.72,0,0,1,0,165.377V31.72A31.72,31.72,0,0,1,31.72,0H165.377A31.72,31.72,0,0,1,197.1,31.72V165.377A31.72,31.72,0,0,1,165.377,197.1ZM31.72,10.04A21.742,21.742,0,0,0,10.04,31.72V165.377a21.742,21.742,0,0,0,21.742,21.742h133.6a21.742,21.742,0,0,0,21.742-21.742V31.72A21.742,21.742,0,0,0,165.377,9.978Z" fill="#222f3e"/>
        <path id="Path_106" data-name="Path 106" d="M9.329,107.878a4.989,4.989,0,0,1-4.989-4.989V22.818A18.478,18.478,0,0,1,22.818,4.34h106.8A18.478,18.478,0,0,1,148.1,22.818V76.157a5.174,5.174,0,1,1-10.348,0V22.695a8.377,8.377,0,0,0-8.13-8.13H22.695a8.377,8.377,0,0,0-8.13,8.13v80.071a4.989,4.989,0,0,1-5.235,5.112Z" transform="translate(22.391 22.391)" fill="#f39c12"/>
        <path id="Path_107" data-name="Path 107" d="M129.383,76.236H22.458A18.478,18.478,0,0,1,4.473,61.269,4.989,4.989,0,0,1,5.766,56.9L34.346,27.208a29.38,29.38,0,0,1,12.319-7.7,28.7,28.7,0,0,1,29.257,7.7L90.641,42.421l14.721-15.213a28.518,28.518,0,0,1,41.329,0,5.051,5.051,0,0,1,1.417,3.449V57.881a18.478,18.478,0,0,1-18.724,18.355ZM113.246,66.011h16.076a8.377,8.377,0,0,0,8.192-8.13V32.813a18.478,18.478,0,0,0-17.308-3.7,19.032,19.032,0,0,0-8.192,5.051L97.109,49.628ZM15.067,61.7a8.315,8.315,0,0,0,7.391,4.558H99.326l-30.8-32.09a18.478,18.478,0,0,0-18.478-4.989,18.971,18.971,0,0,0-8.192,5.051Z" transform="translate(22.628 94.13)" fill="#222f3e"/>
        <path id="Path_108" data-name="Path 108" d="M43.811,22.846A13.366,13.366,0,1,1,30.446,9.48,13.366,13.366,0,0,1,43.811,22.846Z" transform="translate(88.121 48.91)" fill="#f39c12"/>
      </g>
      <text id="Place_Your_Image_Here" data-name="Place Your Image Here" transform="translate(1285 777)" fill="#222f3e" font-size="24" font-family="SegoeUI, Segoe UI"><tspan x="-119.203" y="0">Place Your Image Here</tspan></text>
    </g>
  </g>
</svg>`;
}
